import {clearString, FullAlphabet, EngAlphabet, rotateAlphabet} from "../helpers/stringHelpers";

const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh = false, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input, hasCh)//.replaceAll(/[ ]/g,'')
        missing.forEach((char) => {
            if (char !== 'ch')
                cleared = cleared.replaceAll(char, '')
        })
        let characters = cleared.split('');//.forEach((char)=>{ });
        let arrow = params[1].split(/[, ]/g).filter((a)=>a)
        let fake_i = 0
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            if (char.match(/[.,?! ]/)) {
                cyphered.push(char);
            } else {
                let chr = rotateAlphabet(parseInt(arrow[fake_i % arrow.length]), hasCh)[hasCh ? FullAlphabet.indexOf(char) : EngAlphabet.indexOf(char)];
                cyphered.push(chr);
                fake_i++;
            }

        }

        return cyphered.join(sep)
            .replaceAll('*', 'ch')
    },
    decypher: function (input, hasCh = false, missing = [], params) {
        let deciphered = []
        let cleared = clearString(input, hasCh)
        // let characters = input.replaceAll(/ {2}/g,' ').split(SEPARATOR);//.forEach((char)=>{ });
        let characters = cleared.split('');//.forEach((char)=>{ });
        let arrow = params[1].split(/[, ]/g).filter((a)=>a)
        let fake_i = 0
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            if (char.match(/[.,?! ]/)) {
                deciphered.push(char);
            } else {
                let chr = hasCh ?
                    FullAlphabet[rotateAlphabet(parseInt(arrow[fake_i % arrow.length]), hasCh).indexOf(char)] :
                    EngAlphabet[rotateAlphabet(parseInt(arrow[fake_i % arrow.length]), hasCh).indexOf(char)];
                deciphered.push(chr);
                fake_i++;
            }

        }
        return deciphered.join('').replaceAll('*', 'ch')
    },
};

export default {...methods,SEPARATOR}